import React from 'react';
import { CtaButton, CurrencyNote } from '../CtaButton';
import { Accent } from './SectionHeading';
import { MOCKUP_URL } from '../../data/images';

/** Section 15 — final push back to the checkout button. */
export function FinalCtaSection() {
  return <section aria-labelledby="final-heading" className="bg-brand-blush px-5 py-16 lg:px-8 lg:py-24" data-id="element-81" data-mp="1500oj9rakscn">
      <div className="mx-auto max-w-4xl rounded-[32px] bg-white px-6 py-12 text-center shadow-[0_60px_120px_-60px_rgba(120,70,80,0.6)] sm:px-12 lg:py-16" data-id="element-82" data-mp="100xhjjrr4c21">
        <img src={MOCKUP_URL} alt="Brow Instructor Ready — six volumes and digital resources" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto block w-full max-w-[600px] object-contain" style={{
        filter: 'drop-shadow(0 22px 26px rgba(120, 96, 56, 0.2))'
      }} data-id="element-83" data-mp="8cvqof4cs0aa" />

        <p className="mt-8 font-display text-[1.3rem] italic text-brand-charcoal/60" data-id="element-84" data-mp="3ktixftzln2ne">
          Your next brow class is coming.
        </p>
        <h2 id="final-heading" className="mx-auto mt-3 max-w-3xl font-display text-[2.4rem] font-bold leading-[1.04] text-brand-charcoal sm:text-[3.1rem]" data-id="element-85" data-mp="2kqh2cw6dp0sa">
          This Time, <Accent data-id="element-86" data-mp="2ui4qoo7n21pj">Don’t Start With a Blank Page.</Accent>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-[16px]" data-id="element-87" data-mp="2zgemn116t6c7">
          Get the system that brings together professional brow education, visual teaching resources,
          student practice, troubleshooting and assessment in one structured solution.
        </p>

        <div className="mt-9" data-id="element-88" data-mp="2bp92was4ltwm">
          <CurrencyNote data-id="element-89" data-mp="2bp0r6m7qoun0" />
        </div>
        <CtaButton label="Yes! I Want to Prepare My Classes Faster" className="mt-3 w-full sm:w-auto sm:min-w-[440px]" data-id="element-90" data-mp="2frnq172tvftp" />
        <p className="mt-4 font-body text-[12px] text-brand-charcoal/55" data-id="element-91" data-mp="3n68xxe5uymuc">
          Brow Instructor Ready™ • Digital Access • One-Time Payment
        </p>

        <p className="mt-12 border-t border-brand-charcoal/10 pt-8 font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-92" data-mp="3r8x6dkqntrqs">
          Less Time Preparing. <Accent data-id="element-93" data-mp="1n2y9rd6m1hpg">More Time Teaching.</Accent>
        </p>
      </div>
    </section>;
}